module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_sweden.f6fa7127.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_sweden.png
// module id = 1246
// module chunks = 16